import { createContext } from "react";

const ContextoPorcentagem = createContext();

export default ContextoPorcentagem;
